module.exports = __webpack_public_path__ + "static/1-ef58c6042f5ae7798d4dee6eecbf5b29.jpg";